import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {observer, inject} from 'mobx-react';

const etaBoxHeader = {
    "fontFamily": "GraphikLight",
    "fontSize": "1.6em"
};

const etaBoxWrapper = {
    'width': '18.5%',
};

@inject('RootStore')
@observer
export default class LiveOrderStreamPanelEtaBox extends Component {

    render() {
        const mainEtaBoxStyle = {
            borderRadius: "8pt",
            padding: "3%",
            backgroundColor: this.props.RootStore.styleStore.currentStylesDict.orderStreamPanelMainEtaBoxColor,
            color: this.props.RootStore.styleStore.currentStylesDict.orderStreamPanelMainEtaTextColor
        };

        const etaBoxBody = {
            "fontFamily": "GraphikSemiBold",
            "fontSize": "1.7em",
            "letterSpacing": ".5pt",
            "color": this.props.RootStore.styleStore.currentStylesDict.orderStreamPanelMainEtaTextColor
        };
        return (
            <Flexbox flexDirection="column" alignItems="flex-end" style={etaBoxWrapper}>
                <Flexbox flexDirection="column" alignItems="flex-end" style={mainEtaBoxStyle}>
                    <Flexbox justifyContent="flex-end" style={etaBoxHeader}>
                        Wait Time
                    </Flexbox>
                    <Flexbox justifyContent="center" style={etaBoxBody}>
                        {this.props.RootStore.orderStore.mainShopEta} MIN
                    </Flexbox>
                </Flexbox>
            </Flexbox>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/live_order_stream_panel/live_order_stream_panel_eta_box.jsx